'use client';
import Link from 'next/link';
import {
  SectLabel,
  SectLede,
  V4CtaButton,
  V4GhostButton,
} from '@/components/landing/v4-shared';
import { MagneticCta } from '@/components/marketing/MagneticCta';
import {
  BRAND,
  INTEGRATIONS_INDEX_COPY,
} from '@/lib/marketing/messaging-bank';

/**
 * V4 cyan-pillar hero for /integrations.
 *
 * Magnetic-feel cursor on the primary CTA via the shared MagneticCta
 * primitive (motion-gated by `prefers-reduced-motion`).
 */
export function IntegrationsHero({ totalCount }: { totalCount: number }) {
  return (
    <section className="integrations-hero" aria-labelledby="integrations-hero-heading">
      <div style={{ padding: '0 24px' }}>
        <nav aria-label="Breadcrumb" className="integrations-crumbs">
          <Link href="/">Home</Link>
          <span className="integrations-crumbs__sep" aria-hidden="true">/</span>
          <span className="integrations-crumbs__here">Integrations</span>
        </nav>

        <SectLabel color="var(--cyan-glow)">
          {`Integrations · ${totalCount}+ native partners`}
        </SectLabel>

        <h1 id="integrations-hero-heading" className="integrations-hero__h1">
          BizRnR <em>Integrations</em>
        </h1>
        <SectLede className="speakable-summary">
          {INTEGRATIONS_INDEX_COPY.lede}
        </SectLede>

        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
          <MagneticCta>
            <V4CtaButton href={INTEGRATIONS_INDEX_COPY.ctaPrimary.href} size="lg">
              {INTEGRATIONS_INDEX_COPY.ctaPrimary.label}
            </V4CtaButton>
          </MagneticCta>
          {INTEGRATIONS_INDEX_COPY.ctaSecondary && (
            <V4GhostButton
              href={INTEGRATIONS_INDEX_COPY.ctaSecondary.href}
              variant="cyan"
              size="lg"
            >
              {INTEGRATIONS_INDEX_COPY.ctaSecondary.label}
            </V4GhostButton>
          )}
        </div>
        <p
          style={{
            marginTop: 18,
            fontFamily: 'var(--font-geist-mono)',
            fontSize: 11,
            letterSpacing: '0.18em',
            textTransform: 'uppercase',
            color: 'var(--dim)',
          }}
        >
          {BRAND.primaryCtaShort}
        </p>
      </div>
    </section>
  );
}
